<template>
    <div :style="screenHeight">
        <div class="fixed_search">
            <div class="fixed_search_input">
                <Input v-model="triggerName" placeholder="请输入名称" clearable/>
            </div>
            <div class="fixed_search_input">
                <Select v-model="triggerState" placeholder="请选择状态" clearable>
                    <Option v-for="item in triggerStateList" :value="item.value" :key="item.value">{{item.label}}</Option>
                </Select>
            </div>
            <div class="fixed_search_input">
                <Input v-model="triggerDescribe" placeholder="请输入备注" clearable/>
            </div>
            <div class="fixed_operation_btn" style="width: auto">
                <Button type="primary" @click="initSearch">查询</Button>
                <Button v-if="roleList['3_d-3-1']" type="info" @click="addTrigger">添加</Button>
            </div>
          <div class="fixed_operation_btn" style="margin-top:-3px">
            <Tooltip class="tips_font" placement="bottom">
              <div slot="content">
                <p>触发器说明：</p>
                <p>1、流程触发器为不包含“XXX以来的时长”类条件的触发器，需手动创建满足条件的工单或修改工单数据来触发，不会自动触发；</p>
                <p>2、定时触发器为含有“XXX以来的时长”类条件的触发器，系统每30秒会自动查询符合定时触发器条件的工单，并对这些工单执行对应定时触发器中的执行操作；</p>
                <p>3、为避免多次重复触发定时触发器的情况，时间判断条件需选择“是”；</p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;若选择“小于”、“大于”，则还需添加与触发条件相悖的执行操作（比如条件含有状态为处理中，则执行操作需更改工单为其他状态），否则无法保存；</p>
                <p>4、未分配和已分配以来时长条件目前需要通过创建以来时长以及状态为未分配、已分配来组合实现，且仅能作用于创建后即为未分配、已分配的工单。</p>
              </div>
              <img src="../../../assets/image/homeAsk.png"/>
            </Tooltip>
          </div>
        </div>
        <div class="fixed_table">
          <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
          <div class="table_head">
            <table>
              <tr>
                <th v-for="item in tableHeadList" class="font_style_set" style="width:25%">{{item.label}}</th>
                <th class="font_style_set" style="width:25%">操作</th>
              </tr>
            </table>
          </div>
          <div style="border-bottom: 1px solid rgb(235, 238, 245);" class="footer_style" :style="tableHeight">
            <table class="table_head_footer">
              <tr v-for="(item,index) in tableContentList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
                <td :title="item.triggerName" style="width:25%">{{item.triggerName}}</td>
                <td :title="item.triggerState == '1' ? '启用' : '禁用'" style="width:25%">{{item.triggerState == "1" ? "启用" : "禁用"}}</td>
                <td :title="item.triggerDescribe" style="width:25%">{{item.triggerDescribe}}</td>
                <td class="template_table_btn" style="width:25%">
                  <span class="search_btn" v-if="roleList['3_d-3-2']" @click="openTrigger(item.id,item.triggerState)">{{item.triggerState == "0" ? "启用" : "禁用"}}</span>
                  <span class="search_btn" v-if="roleList['3_d-3-3']" @click="editTrigger(item.id)">编辑</span>
                  <span class="search_btn" v-if="roleList['3_d-3-4']" @click="delTrigger(item.id)">删除</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="page_style">
          <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
          <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
        </div>
        <FlowTriggerPop :showPop="showPop" @closeTriggerPop="closeTriggerPop" :triggerId="triggerId"></FlowTriggerPop>
    </div>
</template>
<script>
import {publicFunClass} from '@/components/js/PublicFunClass.js'
import FlowTriggerPop from '@/components/systemSetup/worknote/FlowTriggerPop.vue'
export default {
    name: "Flowtrigger",
    mixins:[publicFunClass],
    components:{
        FlowTriggerPop
    },
    props:{
    },
    data(){
      return{
          showPop: false,
          total:0,
          spinShow: false,
          pageSizeList:[10,20,30,40,50,100,200],
          currentPage:1,
          speedChangePage: 1,
          pageSize:20,
          roleList: JSON.parse(localStorage.getItem("roleList")),
          screenHeight:{height:''},
          tableHeight:{height:''},
          triggerName:'',
          triggerState:'',
          triggerStateList:[{value:"1",label:"启用"},{value:"0",label:"禁用"}],
          triggerDescribe:'',
          tableHeadList:[{value:"triggerName",label:"名称"},{value:"triggerState",label:"状态"},{value:"triggerDescribe",label:"备注"}],
          tableContentList:[],
          triggerId:"-1"
      }
    },
    methods:{
        initSearch:function(){
          let param = {
            id : "",
            triggerName : this.triggerName,
            triggerState : this.triggerState,
            triggerDescribe : this.triggerDescribe,
          }
          let that = this;
          this.$http.post("trigger/toIndex.json",param) .then(function (res) {
                let result=res.data.flag;
                if(result!="666"){
                  that.$Message.error(res.data.msg);
                  return false;
                }
                that.tableContentList = res.data.obj.list.content;
                that.total = res.data.obj.list.totalSize;
              })
        },
        addTrigger:function(){
          this.triggerId = "";
          this.showPop = true;
        },
        editTrigger:function(id){
          this.triggerId = id;
          this.showPop = true;
        },
        openTrigger:function(id, state){
          let param = {
            id : id,
            triggerState: state,
            journalType:state == "0" ? "工单配置=>流程触发器=>启用触发器" : "工单配置=>流程触发器=>禁用触发器",
            menuId: "3_d-3-2",
          }
          let that=this;
          this.$Modal.confirm({
            title: '提示',
            content: state == "0" ? "是否启用触发器" : "是否禁用触发器" ,
            onOk: () => {
              that.$http.post("trigger/doEnableOrDisable.json",param) .then(function (res) {
                let result=res.data.flag;
                if(result!="666"){
                  that.$Message.error(res.data.msg);
                  return false;
                }
                that.$Message.success(res.data.msg);
                that.initSearch();
              })
            }
          });
        },
        delTrigger:function(id){
          let param = {
            id : id,
            journalType:"工单配置=>流程触发器=>删除触发器",
            menuId:"3_d-3-4",
          }
            let that=this;
          this.$Modal.confirm({
            title: '提示',
            content: "是否删除触发器",
            onOk: () => {
              that.$http.post("trigger/doDelete.json",param) .then(function (res) {
                let result=res.data.flag;
                if(result!="666"){
                  that.$Message.error(res.data.msg);
                  return false;
                }
                that.$Message.success(res.data.msg);
                that.initSearch();
              })
            }
          });
        },
        closeTriggerPop:function(flag){
            this.showPop = false;
            this.triggerId = "-1";
            if(flag){
              this.initSearch();
            }
        },
    },
    created(){
        this.screenHeight.height=this.mountHeight(92);
        this.tableHeight.height=this.mountHeight(220);
        this.initSearch();
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/worknote/FlowTrigger.vue